import axios from "axios"
import router from "@/router/router"

export default {
	namespaced: true,
	state: {
		user: {
			username: undefined,
			email: undefined,
			roles: [],
			permissions: [],
			modules: [],
			logged: false,
			organization: undefined
		},
		approved: undefined,
		organization: undefined,
		username: undefined,
		email: undefined,
		logged: undefined,
		roles: [],
		permissions: [],
		modules: [],
		loaded: false,
		loginErr: 0,
		isSuperAdmin: false,
		organization_logo: undefined,
		notifications: [],
		pwd_exp: undefined
	},
	getters: {
		user: state => state.user,
		username: state => state.username,
		email: state => state.email,
		logged: state => state.logged,
		roles: state => state.roles,
		permissions: state => state.permissions,
		modules: state => state.modules,
		isAdmin: state => state.roles.some(({ name }) => name === "administrator"),
		isSuperAdmin: state => state.roles.some(({ name }) => name === "full-administrator"),
		loaded: state => state.loaded,
		organization: state => state.organization,
		loginErr: state => state.loginErr,
		approved: state => state.approved,
		organizationLogo: state => state.organization_logo,
		notifications: state => state.notifications.filter(x => !x.read),
		read_notifications: state => state.notifications.filter(x => x.read),
		pwd_exp: state => state.pwd_exp
	},
	mutations: {
		mutate(state, payload, element) {},

		LOGIN_SUCCESS(state, payload) {
			state.logged = true
			if(payload && payload.pwd_exp){
				state.pwd_exp = payload.pwd_exp
			}
			//state.username = payload ? payload.username : undefined;
		},
		LOGIN_FAILED(state, err_code) {
			state.username = undefined
			state.email = undefined
			state.roles = []
			state.permissions = []
			state.logged = false
			state.loginErr = err_code
		},

		AUTH_FAILED(state) {
			state.username = undefined
			state.email = undefined
			state.roles = []
			state.permissions = []
			state.logged = false
		},

		MODULES(state, payload) {
			state.modules = payload.modules
		},

		USER(state, payload) {
			state.roles = payload.roles
			state.permissions = payload.permissions
			state.logged = payload.isAuth
			state.organization = payload.organization

			state.username = payload.username
			state.user.username = payload.username
			state.user.roles = payload.roles
			state.user.id = payload.id
			state.user.permissions = payload.permissions
			state.user.modules = payload.modules
			state.user.logged = payload.isAuth
			state.user.organization = payload.organization
			state.approved = payload.approved
			state.loaded = true
		},

		LOGO(state, payload) {
			state.organization_logo = payload
		},

		ADD_NOTIFICATIONS(state, payload) {
			state.notifications.push(payload)
		},
		CLEAR_NOTIFICATIONS(state) {
			state.notifications = []
		}
	},
	actions: {
		async doLogin({ state, commit, rootState, dispatch }, credentials) {
			state.loginErr = 0
			const path = credentials.purpose && credentials.purpose === "school" ? "organizationLogin" : "login"

			let return_err = await axios
				.post(`${process.env.VUE_APP_API_URL}/api/auth/${path}`, credentials)
				.then(res => {
					if (credentials.purpose && credentials.purpose === "school") {
						state.organization.confirmed = true
						state.organization.confirmation_code = ""
						router.replace({ path: "/login", name: "login" }).catch(err => {
							console.error(err)
							if (err.name !== "NavigationDuplicated") return false
						})
						return false
					} else if (credentials.purpose && credentials.purpose === "user" && !res.data.org_confirmed) {
						router.replace({ path: "/login", name: "login" }).catch(err => {
							console.error(err)
							if (err.name !== "NavigationDuplicated") return false
						})
					} else {
						if (res.data.org_confirmed) {
							commit("modules/OPEN_LOADING", null, { root: true })
							localStorage.setItem("JWT", res.data.jwt)
							commit("LOGIN_SUCCESS", res.data)
							dispatch("doUser")
						} else {
							commit("LOGIN_FAILED", 1) //organization not confirmed
							return true
						}
					}
					router.push({ path: "/home", name: "home" }).catch(err => {
						console.error(err)
						if (err.name !== "NavigationDuplicated") return false
					})
					return false
				})
				.catch(err => {
					if(err.response.data.Message =="expired-password") commit("LOGIN_FAILED", 4)
					else commit("LOGIN_FAILED", 2)
					console.error(err)
					return true
				})

			return return_err
		},

		doLogout({ state, commit, rootState }) {
			localStorage.removeItem("JWT")
			router.push({ path: "/login", name: "login" }).catch(err => {
				if (err.name !== "NavigationDuplicated") {
					return false
				}
			})

			commit("LOGIN_FAILED", 3)

			commit("CLEAR_NOTIFICATIONS")
		},

		async doReset({ commit }) {
			commit("AUTH_FAILED")
		},

		async doUser({ commit, dispatch }) {
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/auth/testAuth", {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(({ data: payload }) => {
					const admin = payload.roles.some(({ name }) =>
						["administrator", "full-administrator"].includes(name)
					)
					if (!admin) {
						var modules = []
						payload.permissions.forEach(async function (permission) {
							var found = false
							for (let module of modules) {
								if (module.id == permission.module.id) {
									found = true
									break
								}
							}
							if (!found) modules.push(permission.module)
						})
						payload.modules = modules
					}
					commit("USER", payload)
					dispatch("organization/doModules", null, { root: true })
					dispatch("doImage")
				})
				.catch(err => console.error(err))
		},

		doImage({ state, commit, rootState }) {
			var payload = {
				custom_field_name: "logo scuola",
				owner_type: "organizations",
				owner_id: state.user.organization.id
			}
			axios
				.post(process.env.VUE_APP_API_URL + "/api/customfieldvalues/getImage", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					var file = res.data.file
					commit("LOGO", "data:image/png;base64," + file)
				})
				.catch(err => {
					console.error(err)
					commit("LOGO", "")
				})
		},

		async doAdd({ state, commit, getters }, payload) {
			var user = undefined
			var error = undefined
			var url = getters.isSuperAdmin ? "addUserToOrganizationBySuperAdmin" : "addUserToOrganizationByAdmin"
			await axios
				.post(process.env.VUE_APP_API_URL + "/api/user/" + url, payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					user = res.data.user
				})
				.catch(err => {
					error = err.response.data
					console.error(err)
				})

			return { user: user, err: error }
		},

		addNotifications({ state, commit }, payload) {
			//TO DO: code per identificare la notifica in modo da evitare di aggiungere una di uguale
			for (let item of state.notifications) {
				if (item.code == payload.code && item.read == payload.read) return
			}

			commit("ADD_NOTIFICATIONS", payload)
		},
		removeNotifications({ state, commit }, payload) {
			var indx = state.notifications.findIndex(x => x.code == payload)

			let removed = state.notifications.splice(indx, 1)
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/notification/delete",
					{ id: removed[0].id },
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {})
				.catch(err => {})
		},
		moveNotifications({ state, commit }, payload) {
			state.notifications.forEach(not => {
				if (not.code == payload) not.read = true
			})
		}
	}
}
